import { useEffect, useState } from "react";
import { ItemDetails } from "./ItemDetails";
import { ItemNavigation } from "./ItemNavigation";
import { modalStackManager } from "../modalStack";

export default function ItemModal({ item, onClose, showNavigation, onNavigate, totalItems, index }) {
  const [modalId] = useState(() => `modal-${Math.random().toString(36).substr(2, 9)}`);
  const [isTopModal, setIsTopModal] = useState(false);
  const [copied, setCopied] = useState(false);
  const shareLink = `https://pixelore.wiki/lookup/items/${item.id}`;

  useEffect(() => {
    modalStackManager.push(modalId);

    const unsubscribe = modalStackManager.subscribe(() => {
      setIsTopModal(modalStackManager.isTop(modalId));
    });

    return () => {
      modalStackManager.pop();
      unsubscribe();
    };
  }, [modalId, item.id]);

  const handleShare = () => {
    navigator.clipboard.writeText(shareLink).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape" && isTopModal) {
        onClose();
      }
    };

    window.addEventListener("keydown", handleEsc);
    return () => {
      window.removeEventListener("keydown", handleEsc);
    };
  }, [onClose, isTopModal, modalId]);

  const handleClose = () => {
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex justify-center items-center p-1 md:p-3">
      <div className="main-modal relative bg-[var(--panel-bg-color)] rounded-xl max-h-full max-w-screen md:max-h-[90vh] overflow-y-auto w-full md:max-w-5xl p-6">
        <div className="mt-4 flex justify-start">
          <button onClick={handleShare} className="flex items-center gap-2 text-sm">
            {copied ? "Copied!" : "Copy link"}
            <i className="fa-solid fa-share" />
          </button>
        </div>
        <button onClick={handleClose} className="absolute top-4 right-4 text-xl">
          ×
        </button>

        <ItemDetails item={item} />

        {showNavigation && <ItemNavigation onNavigate={onNavigate} currentIndex={index} totalItems={totalItems} />}
      </div>
    </div>
  );
}
